







import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

/**
 * Blah
 */
@Component({ name: 'v-icon' })
export default class VIcon extends Mixins(Modifiable) {
    /**
     * Icon name
     *
     * Reference: https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'question-circle' })
    icon!: string

    /**
     * Icon size
     */
    @Prop({ type: String, default: 'md' })
    size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'

    /**
     * Icon container size
     */
    @Prop({ type: String, default: 'md' })
    containerSize!: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'

    @Prop({ type: Boolean, default: false })
    solid!: boolean

    /**
     * Icon class prefix
     */
    get prefix(): string {
        return `fa${this.solid ? 's' : 'r'} fa-`
    }
}
